import transform from '../../../utils/ResponseTransformator'
import mapResponseToSettings from '../mappers/mapResponseToSettings'
import { IData } from './response'

export default async function(response: Response) {
  let text: string = await response.text()
  text = transform(text)
  const json: IData = JSON.parse(text)
  const rooms = json.items.map(mapResponseToSettings)

  return rooms.shift()
}
